<template>
	<div class="independent-wrapper" ref="box">
		<div class="fix-img">
			<div><img src="../../../static/images/result/baogaobg1.png" /></div>
			<div class="image" :style="{'height':fixedImgHeight + 'px'}" >
				<img :style="{'height':fixedImgHeight + 'px'}" src="../../../static/images/result/pinjietu.png" alt="" />
			</div>
		</div>
		<div class="content" ref="content">
			<div class="con" ref="con">
				<!--脉象报告-->
				<div class="wrapper">
					<div class="item item-pulseReport">
						<div class="pulseReport">舌面报告</div>
						<div class="line pulseReportBottom">
							<div class="left" style="margin-left: 30px;">
								<div class="left-img" v-if="visitInfo.patient">
									<img v-show="visitInfo.patient.gender == '男'"
										src="../../../static/images/pluse/man.png" />
									<img v-show="visitInfo.patient.gender == '女'"
										src="../../../static/images/pluse/woman.png" />
								</div>
								<div class="left-right">
									<div class="p" v-if="visitInfo.patient">
										<span class="name">
											<i class="i">姓 名：</i>
											<i>{{ visitInfo.patient.name }}</i>
										</span>
										<span>
											<i class="i">性 别：</i>
											<i>{{ visitInfo.patient.gender }}</i>
										</span>
										<span>
											<i class="i">年 龄：</i>
											<i>{{ age }}岁</i>
										</span>
									</div>
									<div class="p">

										<span v-if="visitInfo">
											<i class="i">时 间：</i>
											<i>{{ visitInfo.visitTime }}</i>
										</span>
									</div>
								</div>
							</div>
							<div class="right">
								<el-button size="large" id="print-button" class="print" @click="printShort">打印</el-button>
								 <el-button size="large" class="print" @click="printPDF">导出</el-button>
								<el-button size="large" v-if="outVisitId" @click="synchronization" style="margin-right: 20px;">同步辅诊
								</el-button>
								<el-button size="large" v-if="device" @click="remeasure">重新测量</el-button>
								<el-button size="large" v-else class="back" @click="backList">返回列表</el-button>
							</div>
						</div>
					</div>
				</div>
				<div class="wrapper-con">
					<!--总体结果-->
					<div class="item pulseResult-item" v-if="reportResultList.length>0">
						<div class="pulseDetail"><span>诊断结果</span></div>
						<div class="item-line pulseResult" style="height:auto">
							<div class="pulseResult-left" style="width: 100%;padding-bottom: 20px;">
								<div class="line pluse" style="margin-top:70px;margin-left: 20px;">
									<span>
										<i class="i">诊断结果：</i>
									</span>
									<span style="position: relative;width: calc(100% - 150px);">

										<i style="margin-right:10px" v-for="(item,index) in reportResultListVal" :key="index">
											<i v-if="reportResultListVal.length>1">{{index+1}}.</i>
											{{item}}
										</i>
									</span>
								</div>

								<div class="line pluse" v-for="(item,index) in reportResultList" :key="index"
									style="margin-top: 16px;margin-left: 20px;">
									<span>

										<i class="i">
											<i v-if="reportResultList.length>1">{{index+1}}.</i>
											{{item.result}}
										</i>
										<i>{{item.about}}</i>
									</span>

								</div>
							</div>
							<div class="pulseResult-right" style="display: none;">
								<div class="circleBox">
									<el-progress type="circle" :show-text="false" :percentage="75" :stroke-width="8"
										stroke-linecap="square" />
									<div class="circleCenter">
										<div>75分</div>
										<span>健康得分</span>
									</div>
								</div>

								<div class="radarChart" id="radarChart" ref="radarChart" style="display: none;"></div>
							</div>
						</div>
						<div class="line margin26 add-p add-p-border"
							style="margin-top: 0;padding-top: 20px;display: none;" v-if="pulseResultList.length > 0">
							<ul class="pulseDec">
								<li v-for="(item, index) in pulseResultList" :key="index">
									<div class="dec-con">
										<div class="dec-con-left">
											<img src="../../../static/images/pluse/pluseDes.png" />
											<span :class="item.name.length > 1 ? 'twoWord' : ''">
												{{item.name}}
											</span>                     
										</div>
										<div class="dec-con-right">
											<div class="son">
												{{ item.about }}
											</div>
										</div>
									</div>
								</li>
							</ul>
						</div>
					</div>
					<!--面象分析-->
					<div class="item item-item " v-if="explainList.length" style="display: none;">
						<div class="item-cpmList">
							<div class="pulseDetail"><span>面象分析</span></div>
					
							<div class="item-line constitution tongueConstitution constitutionOne">
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con">
											<img v-if="faceUrl" :src="GLOBAL.imgPath + faceUrl" />
											<img v-else src="../../../static/images/face/mianzhen.png" />
										</div>
									</div>
									<div class="medicine-right">
					
										<div class="medicine-con">
											<div class="medicine-line" v-if="faceColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【面色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{faceColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in faceColorData">
													<div class="p-left tongueColorLeft">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right tongueColorRight">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="glossData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【光泽度】</span>
													<span style="font-size: 14px;font-weight:400">
														{{glossDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in glossData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="lipColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【唇色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{lipColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in lipColorData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="eyeData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【眼眶】</span>
													<span style="font-size: 14px;font-weight:400">
														{{eyeDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in eyeData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								
							</div>
						</div>
					</div>
					<!--舌象分析-->
					<div class="item item-item " v-if="explainList.length">
						<div class="item-cpmList">
							<div class="pulseDetail"><span>舌面象分析</span></div>

							<div class="item-line constitution tongueConstitution constitutionOne">
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con">
											<img class="faceImg" v-if="tongueUrl" :src="GLOBAL.imgPath + tongueUrl" />
											<img class="faceImg" v-else src="../../../static/images/face/shezhen.png" />
										</div>
									</div>
									<div class="medicine-right">

										<div class="medicine-con">
											<div class="medicine-line" v-if="tongueColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【舌色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{tongueColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in tongueColorData">
													<div class="p-left tongueColorLeft">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right tongueColorRight">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="tongueShapeData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【舌形】</span>
													<span style="font-size: 14px;font-weight:400">
														{{tongueShapeDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in tongueShapeData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="furColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【苔色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{furColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in furColorData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="furTextureData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【苔质】</span>
													<span style="font-size: 14px;font-weight:400">
														{{furTextureDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in furTextureData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="faceColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【面色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{faceColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in faceColorData">
													<div class="p-left tongueColorLeft">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right tongueColorRight">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="glossData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【光泽度】</span>
													<span style="font-size: 14px;font-weight:400">
														{{glossDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in glossData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="lipColorData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【唇色】</span>
													<span style="font-size: 14px;font-weight:400">
														{{lipColorDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in lipColorData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
											<div class="medicine-line" v-if="eyeData.length>0">
												<div class="medicine-title">
													<span style="font-size: 14px;font-weight:bold">【眼眶】</span>
													<span style="font-size: 14px;font-weight:400">
														{{eyeDataVal.join(',')}}
													</span>
												</div>
												<div class="div" :key="index" v-for="(item,index) in eyeData">
													<div class="p-left">
														<span></span>
														<span>{{item.value}}：</span>
													</div>
													<div class="p-right">
														<span>{{item.significance}}</span>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					
					<!--八纲辨证-->
					<div class="item" style="display: none;">
						<div class="pulseDetail"><span>八纲辨证</span></div>
						<div class="item-line dialectics" v-if="principleList.length > 0">
							<div class="line">
								<div class="chartmain">
									<div class="chartmain-item">
										<div class="chartmain-top">表</div>
										<div id="chartmainbar1"></div>
										<div class="chartmain-bottom">里</div>
										<div class="chartmain-result">
											{{ principleList[0].name }}
										</div>
										<div class="chartmain-dec">
											{{
                        principleList[0].desc ? principleList[0].desc : "暂无"
                      }}
										</div>
									</div>
									<div class="chartmain-item">
										<div class="chartmain-top">实</div>
										<div id="chartmainbar2"></div>
										<div class="chartmain-bottom">虚</div>
										<div class="chartmain-result">
											{{ principleList[1].name }}
										</div>
										<div class="chartmain-dec">
											{{
                        principleList[1].desc ? principleList[1].desc : "暂无"
                      }}
										</div>
									</div>
									<div class="chartmain-item">
										<div class="chartmain-top">热</div>
										<div id="chartmainbar3"></div>
										<div class="chartmain-bottom">寒</div>
										<div class="chartmain-result">
											{{ principleList[2].name }}
										</div>
										<div class="chartmain-dec">
											{{
                        principleList[2].desc ? principleList[2].desc : "暂无"
                      }}
										</div>
									</div>
									<div class="chartmain-item">
										<div class="chartmain-top">阳</div>
										<div id="chartmainbar4"></div>
										<div class="chartmain-bottom">阴</div>
										<div class="chartmain-result">
											{{ principleList[3].name }}
										</div>
										<div class="chartmain-dec">
											{{
                        principleList[3].desc ? principleList[3].desc : "暂无"
                      }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--体质辨识-->
					<div class="item item-item " v-if="physiqueList">
						<div class="item-cpmList">
							<div class="pulseDetail"><span>体质辨识</span></div>

							<div class="item-line constitution constitutionOne" v-for="(item, index) in physiqueList"
								:key="index">
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con" v-if="item.images">
											<img v-for="item in item.images.slice(0, 1)" :key="item.name"
												:src="GLOBAL.imgPath + item.path" />
										</div>
									</div>
									<div class="medicine-right">
										<div class="medicine-title">【{{ item.name }}】</div>
										<div class="medicine-con">
											<div class="medicine-line">
												<div class="div">
													<div class="p-left">
														<span></span>
														<span>整体特征：</span>
													</div>
													<div class="p-right">
														<span> {{ item.body }} </span>
													</div>
												</div>
												<!-- <div class="div">
                          <div class="p-left">
                            <span></span>
                            <span>心理特征：</span>
                          </div>
                          <div class="p-right">
                            <span>{{ item.mental }}</span>
                          </div>
                        </div> -->
												<div class="div">
													<div class="p-left">
														<span></span>
														<span>常见表现：</span>
													</div>
													<div class="p-right">
														<span>{{ item.performance }}</span>
													</div>
												</div>
												<!-- <div class="div">
                          <div class="p-left">
                            <span></span>
                            <span>发病倾向：</span>
                          </div>
                          <div class="p-right">
                            <span>{{ item.tend }}</span>
                          </div>
                        </div> -->
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--健康评估-->
					<div class="item item-item" v-if="healthAssessmentList.length>0">
						<div class="item-cpmList">
							<div class="pulseDetail"><span>健康评估</span></div>
							<div style="margin-top: 120px;">
								<div class="symptomTop" v-if="symptomList.length>1">
									{{healthAssessmentList[0].overview}}
								</div>
								<div class="symptomBottom">
									<div class="symptomLeft">
										<div class="symptomTitle"  v-if="symptomListLeft.length>1">
											<div class="symptomItem" v-for="(item, index) in symptomListLeft"
												:key="index"
												:class="healthAssessmentList[0].age.name == '14岁以下'? 'symptomItemChild': '' ">
												<span >{{ item.symptom }}</span>
											</div>
										</div>

										<div class="image">
											<img v-if="healthAssessmentList[0].age.name == '14岁以下'"
												:src="GLOBAL.imgPath + healthAssessmentImgPath" alt=""
												style="margin-top: 80px;" />
											<img v-else :src="GLOBAL.imgPath + healthAssessmentImgPath" alt="" />
										</div>
										<div class="symptomTitle"  v-if="symptomListRight.length>0">
											<div class="symptomItem symptomItemRight"
												v-for="(item1, index1) in symptomListRight" :key="index1"
												:class="healthAssessmentList[0].age.name == '14岁以下'? 'symptomItemChildRight': ''">
												<span>{{ item1.symptom }}</span>
											</div>
										</div>
									</div>
									<div class="symptomRight">
										<div class="symptomItems" v-if="symptomList.length>0">
											<div :class="symptomList.length==1?'symptomItemOne':''" class="symptomItem" v-for="(item, index) in symptomList"
												:key="index">
												<div class="title" v-if="item.symptom!='无' "><span></span>{{ item.symptom }}</div>
												<div class="maintenanceOne"  v-if="symptomList.length==1">
													{{healthAssessmentList[0].overview}}
												</div>
												<div class="content">
													<span>健康说明：</span>{{ item.desc }}
												</div>
												<div class="content maintenance"  v-if="item.maintenance">
													<span>保养建议：</span>{{ item.maintenance }}
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>

					<!--理疗保健-->
					<div class="item" v-if="healthPlanList.length>0">
						<div class="pulseDetail"><span>理疗保健</span></div>
						<div class="item-line acupointHealthCare">
							<div class="acupointHealthCare-item" v-if="healthPlanList[0].amAcupointList">
								<div class="divider">
									<img src="../../../static/images/title_left.png" />
									<span>按摩</span>
									<img src="../../../static/images/title_right.png" />
								</div>
								<span class="video" style="display: none;">
									<i>操作视频</i>
									<i @click="goLookVideo('all')" class="el-icon-video-play"></i>
								</span>
								<div class="line margin26 marginAuto acupoint-div"
									v-if="healthPlanList[0].amAcupointList">
									<div class="acupoint" v-for="(item, index) in healthPlanList[0].amAcupointList"
										:key="index">
										<div class="img">
											<div class="acupoint-img-div">
												<img v-for="item in item.images.slice(0, 1)" :key="item.name"
													:src="GLOBAL.imgPath + item.path" />
												<span>{{ item.name }} </span>
											</div>
											<p>
												{{ item.operation }}
											</p>
										</div>
										<div class="acupoint-p">
											<img src="../../../static/images/result/point.png" />
											<span class="bold">位置：</span>
											<span>
												{{ item.position }}
											</span>
										</div>
										<div class="acupoint-p">
											<img src="../../../static/images/result/point.png" />
											<span class="bold">功效：</span>
											<span>
												{{ item.effect }}
											</span>
										</div>
										<div class="acupoint-p">
											<img src="../../../static/images/result/point.png" />
											<span class="bold">经属：</span>
											<span>
												{{ item.belong }}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div class="acupointHealthCare-item">
								<div style="position: relative;" class="acupointHealthCare-item-item"
									v-for="(item, index) in physiotherapyCareList" :key="index">
									<div class="divider">
										<img src="../../../static/images/title_left.png" />
										<span>{{ item.type }}</span>
										<img src="../../../static/images/title_right.png" />
									</div>

									<span class="video" style="display: none;">
										<i>操作视频</i>
										<i @click="goLookVideo('one', item)" class="el-icon-video-play"></i>
									</span>
									<div class="line margin26 marginAuto acupoint-div">
										<div class="acupointHealthCare-left">
											<div class="acupoint" v-if="item.type == '艾灸'">
												<div class="img">
													<div class="acupoint-img-div acupoint-img-div-phy">
														<img class="phyImg"
															src="../../../static/images/aijiuxuewei.png" />
													</div>
												</div>
											</div>
											<div class="acupoint" v-if="item.type == '拔罐'">
												<div class="img">
													<div class="acupoint-img-div acupoint-img-div-phy">
														<img class="phyImg"
															src="../../../static/images/baguanxuewei.png" />
													</div>
												</div>
											</div>
											<div class="acupoint" v-if="item.type == '刮痧'">
												<div class="img">
													<div class="acupoint-img-div acupoint-img-div-phy">
														<img class="phyImg"
															src="../../../static/images/guashaxuewei.png" />
													</div>
												</div>
											</div>
											<div class="acupoint" v-for="(ite, ind) in item.images" :key="ind">
												<div class="img">
													<div class="acupoint-img-div">
														<img :src="GLOBAL.imgPath + ite.path" />
														<span>{{ ite.name }} </span>
													</div>
												</div>
											</div>
										</div>
										<div class="acupointHealthCare-right">
											<div class="acupoint-item" v-if="item.operation">
												<p style="font-weight: bold;" v-html="item.operation"></p>
											</div>
											<div class="acupoint-item">
												<p>
													<span></span>
													<span>总述：</span>
												</p>
												<p v-html="item.ajSummary"></p>
											</div>
											<div class="acupoint-item" v-if="item.type == '刮痧'">
												<p>
													<span></span>
													<span>操作方法：</span>
												</p>
												<p v-html="item.ajOperation"></p>
											</div>
											<div class="acupoint-item">
												<p>
													<span></span>
													<span>功效：</span>
												</p>
												<p v-html="item.ajEfficacy"></p>
											</div>
											<div class="acupoint-item">
												<p>
													<span></span>
													<span>注意事项：</span>
												</p>
												<p v-html="item.ajPrecaution"></p>
											</div>
											<div class="acupoint-item">
												<p>
													<span></span>
													<span>禁忌症：</span>
												</p>
												<p v-html="item.ajContraindication"></p>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>

					</div>

					<!--饮食建议-->
					<div class="item" v-if="dietList">
						<div class="pulseDetail">
							<span>饮食建议</span>
						</div>
						<!-- <div class="tips">
							{{ regimenDetail.dietDesc }}
						</div> -->
						<div class="item-line acupointHealthCare diet-content">
							<div class="line margin26 marginAuto diet-con">
								<div class="diet-div">
									<div class="diet" v-for="(item, index) in dietList" :key="index">
										<div class="tab">
											<span class="one">{{ item.name }}</span>
											<span class="two">{{ item.type }}</span>
										</div>
										<div class="diet-p">
											<img src="../../../static/images/result/point.png" />
											<span class="bold">原料：</span>
											<span>
												{{ item.material }}
											</span>
										</div>
										<div class="diet-p-img">
											<div class="line-img" v-for="(ite, index) in item.images" :key="index">
												<img :src="GLOBAL.imgPath + ite.path" />
												<span>【{{ ite.name }}】</span>
											</div>
										</div>
										<div class="acupoint-p">
											<img src="../../../static/images/result/point.png" />
											<span class="bold">制法：</span>
											<span>
												{{ item.method }}
											</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--运动推荐：healthPlan 配置的 base_sport-->
					<div class="item" v-if="healthPlanList.length > 0 && healthPlanList[0].sportList && healthPlanList[0].sportList.length > 0">
						<div class="pulseDetail"><span>运动推荐</span></div>
						<div class="item-line pulseResult run">
							<div class="pulseResult-bottom" style="margin-top: 0;">
								<div class="bottom-div" v-for="(item, index) in healthPlanList[0].sportList" :key="'sport-' + index">
									<div class="run-left" style="width: 100%;">
										<div class="acupoint-p run-acupoint-p" style="margin-bottom: 8px;">
											<span class="bold" style="font-size: 16px;">{{ item.name }}</span>
										</div>
										<div class="acupoint-p run-acupoint-p">
											<span>{{ item.effect }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--推荐好物：healthPlan 配置的 mall_product-->
					<div class="item" v-if="healthPlanList.length > 0 && healthPlanList[0].recommendProductList && healthPlanList[0].recommendProductList.length > 0">
						<div class="pulseDetail"><span>推荐好物</span></div>
						<div class="item-line pulseResult run">
							<div class="pulseResult-bottom" style="margin-top: 0;">
								<div class="bottom-div" v-for="p in healthPlanList[0].recommendProductList" :key="p.id" style="display: flex; gap: 16px; align-items: center; padding: 8px 0;">
									<div class="run-left" style="flex-shrink: 0; width: 120px;">
										<img :src="GLOBAL.imgPath + p.coverImage" style="width: 120px; height: 120px; object-fit: cover; border-radius: 6px;" v-if="p.coverImage" />
									</div>
									<div class="run-right" style="flex: 1;">
										<div class="acupoint-p run-acupoint-p" style="margin-bottom: 8px;">
											<span class="bold" style="font-size: 16px;">{{ p.name }}</span>
										</div>
										<div class="acupoint-p run-acupoint-p">
											<span style="color: #c0392b; font-weight: bold; font-size: 18px;">¥{{ p.retailPrice }}</span>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--生活建议-->
					<div class="item" v-if="regimenDetail" style="display: none;">
						<div class="pulseDetail"><span>生活建议</span></div>
						<div class="item-line pulseResult run run-life">
							<div class="pulseResult-top">
								<div class="oneDiv">
									<img src="../../../static/images/yangshengjianyi.png" />
									<span class="one">养生建议</span>
								</div>
							</div>
							<div class="pulseResult-bottom">
								<div class="img" style="margin-top:-20px;margin-bottom:25px;" v-if="wellnessList">
									<img style="margin: 0 auto;" :src="GLOBAL.imgPath + wellnessList.images[0].path" />
								</div>
								<div class="twoDiv" style="font-size: 14px;line-height: 25px;">
									{{ wellnessList.content }}
								</div>
							</div>
						</div>
						<div class="item-line pulseResult run add-p-border run-bao-yin" v-if="lifeGuideList.length > 0">
							<div class="pulseResult-top">
								<div class="oneDiv">
									<img src="../../../static/images/yinyueliaofa.png" />
									<span class="one">音乐疗法</span>
								</div>
							</div>
							<div class="pulseResult-bottom" style="margin-top: 0;">
								<div class="bottom-div" style="margin-left:-20px;">
									<div class="acupoint-p run-acupoint-p">
										<span class="bold">音乐推荐：</span>
										<span class="music">
											{{ lifeGuideList[0].musicName }}
										</span>
									</div>
									<div class="acupoint-p run-acupoint-p">
										<span class="bold">听：</span>
										<span style="display: block;">
											{{ lifeGuideList[0].listen }}
										</span>
									</div>
									<div class="acupoint-p run-acupoint-p">
										<span class="bold">念：</span>
										<span style="display: block;">
											{{ lifeGuideList[0].read }}
										</span>
									</div>
									<div class="acupoint-p run-acupoint-p">
										<span class="bold">乐器：</span>
										<span style="display: block;">
											{{ lifeGuideList[0].instrument }}
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--中成药推荐-->
					<div class="item item-item" v-if="regimenDetail && regimenDetail.cpmList" style="display: none;">
						<div class="item-cpmList" v-if="regimenDetail.cpmList.length > 0">
							<div class="pulseDetail"><span>中成药推荐</span></div>
							<div class="tips">
								用药需谨慎，本药品仅供参考，不作为处方依据，请根据药品说明书、适应症等，结合自身情况、症状选用。
							</div>
							<div class="item-line medicine" v-if="regimenDetail.cpmList.length > 0">
								<div class="line margin26 marginAuto acupoint-div">
									<div class="medicine-left">
										<div class="medicine-left-con">
											<img src="../../../static/images/juanzhou.png" />
											<div class="top" v-if="regimenDetail.cpmList[0].syndromes">
												<span></span>
												<span>适应症状：</span>
												<span>
													{{ regimenDetail.cpmList[0].syndromes }}
												</span>
											</div>
											<div class="bottom">
												<ul v-if="regimenDetail.cpmList[0].details.length > 1">
													<li v-for="(item, index) in regimenDetail.cpmList[0]
                              .details" :key="item.id" :class="cpmIndex == index ? 'active' : ''"
														@click="changeCpmList(index)">
														{{ item.name }}
													</li>
												</ul>
											</div>
										</div>
									</div>
									<div class="medicine-right">
										<!-- <div
                      class="medicine-title"
                      v-if="regimenDetail.cpmList[0].details.length > 1"
                    >
                      【 {{ regimenDetail.cpmList[0].details[cpmIndex].name }}】
                    </div> -->
										<div class="medicine-title">
											【 {{ regimenDetail.cpmList[0].name }}】
										</div>
										<div class="medicine-con">
											<div class="medicine-line" v-if="regimenDetail.cpmList[0].majorFunction">
												<p>
													<span></span>
													<span>主治</span>
												</p>
												<p>{{ regimenDetail.cpmList[0].majorFunction }}</p>
											</div>
											<div class="medicine-line" v-if="
                          regimenDetail.cpmList[0].details[cpmIndex]
                            .drugProperties
                        ">
												<p>
													<span></span>
													<span>药性</span>
												</p>
												<p>
													{{
                            regimenDetail.cpmList[0].details[cpmIndex]
                              .drugProperties
                          }}
												</p>
											</div>
											<div class="medicine-line"
												v-if="regimenDetail.cpmList[0].details[cpmIndex].usage">
												<p>
													<span></span>
													<span>用法用量</span>
												</p>
												<p>
													{{ regimenDetail.cpmList[0].details[cpmIndex].usage }}
												</p>
											</div>
											<div class="medicine-line" v-if="
                          regimenDetail.cpmList[0].details[cpmIndex].composition
                        ">
												<p>
													<span></span>
													<span>成份</span>
												</p>
												<p>
													{{
                            regimenDetail.cpmList[0].details[cpmIndex]
                              .composition
                          }}
												</p>
											</div>
											<div class="medicine-line" v-if="
                          regimenDetail.cpmList[0].details[cpmIndex]
                            .contraindication
                        ">
												<p>
													<span></span>
													<span>禁忌</span>
												</p>
												<p>
													{{
                            regimenDetail.cpmList[0].details[cpmIndex]
                              .contraindication
                          }}
												</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<!--膏方/调理颗粒剂-->

					<div class="item" v-if="gfOrKljData" style="padding-bottom: 20px;">

						<div class="pulseDetail">
							<span>{{ gfOrKljData.type }}推荐</span>
						</div>

						<div class="item-line pulseResult run run-life" style="height:auto;">
							<div class="pulseResult-top">
								<div class="oneDiv" style="margin-top:-20px;">
									<span class="one" style="margin-left:0px;font-size: 16px;">
										{{gfOrKljData.name}}
									</span>


									<span class="image" v-if="gfOrKljData.buyUri" @click="goBuy"
										style="cursor: pointer;">
										<img src="../../../static/images/gouwuche.png" alt="" />
										<span>购买</span>
									</span>
								</div>
							</div>
							<div class="pulseResult-bottom">
								<div class="right_gf">
									<div class="image" v-if="gfOrKljData.images" style="position: relative;">
										<img :src="GLOBAL.imgPath + gfOrKljData.images[0].path" alt="" />
									</div>
								</div>
								<div class="left_gf">
									<div class="item_gf">
										<div class="title_gf">功效:</div>
										<div class="content_gf" v-html="gfOrKljData.efficacy"></div>
									</div>
									<div class="item_gf">
										<div class="title_gf">配料:</div>
										<div class="content_gf" v-html="gfOrKljData.ingredient"></div>
									</div>
									<div class="item_gf">
										<div class="title_gf">含量:</div>
										<div class="content_gf">{{ gfOrKljData.content }}克/袋</div>
									</div>
									<div class="item_gf">
										<div class="title_gf">用法:</div>
										<div class="content_gf" v-html="gfOrKljData.usage"></div>
									</div>
									<div class="item_gf">
										<div class="title_gf">禁忌人群:</div>
										<div class="content_gf" v-html="gfOrKljData.contraindication"></div>
									</div>
									<div class="item_gf">
										<span class="title_gf">保质期:</span>
										<span class="content_gf" v-html="gfOrKljData.shelfLife"></span>
									</div>
									<div class="item_gf">
										<span class="title_gf">存储条件:</span>
										<span class="content_gf" v-html="gfOrKljData.storageCondition">
										</span>
									</div>
								</div>

							</div>
						</div>
					</div>
					<!--健康食品-->
					<div class="item" v-if="healthFoodList">
						<div class="pulseDetail"><span>健康食品推荐</span></div>
						<div class="item-line pulseResult run run-life" style="height:auto;">
							<div class="pulseResult-bottom">
								<div class="items_JKSP" v-for="(item, index) in healthFoodList" :key="index">
									<div class="left_JKSP">
										<div class="image" v-if="item.images && item.images.length > 0">
											<img :src="GLOBAL.imgPath + item.images[0].path" alt="" />
										</div>
									</div>
									<div class="right_JKSP">
										<div class="titles_JKSP">
											<span class="name">{{ item.name }}</span>
											<span class="image" v-if="item.buyUri" @click="goBuyJKSP(item.buyUri)"
												style="cursor: pointer;">
												<img src="../../../static/images/gouwuche.png" alt="" />
												<span>购买</span>
											</span>
										</div>
										<div class="item_JKSP">
											<div class="title_JKSP">介绍:</div>
											<div class="content_JKSP" v-html="item.introduction"></div>
										</div>
										<div class="item_JKSP">
											<div class="title_JKSP">产品功效:</div>
											<div class="content_JKSP" v-html="item.efficacy"></div>
										</div>
										<div class="item_JKSP">
											<div class="title_JKSP">产品特性:</div>
											<div class="content_JKSP" v-html="item.characteristic"></div>
										</div>
										<div class="item_JKSP">
											<div class="title_JKSP">适用人群:</div>
											<div class="content_JKSP" v-html="item.applicablePopulation"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import UQRCode from "uqrcodejs";
	import globle from "../../globle/globle";
	
	
	export default {
		data() {
			return {
				GLOBAL:globle,
				visitId: "",
				device: "",
				pulseResult: "",
				chiFirstValue: "",
				visitInfo: {},
				age: 0, //年龄
				regimenDetail: {
					diet: "",
					exercise: "",
					life: "",
				},
				outVisitId: "",
				canvasImg: require("../../../static/images/cunguanchi.png"),
				centerDialogVisible: false,
				timerTwo: null,
				hasTips: 0, //提示
				loginInfo: {},
				principleList: [],
				valOne: "",
				valTwo: "",
				valThree: "",
				valFour: "",
				pulseResultList: [],
				standardList: {},
				pulseResultTrit: [],
				LowStrengthData: [], //低强度
				medialStrengthData: [], //中强度
				highStrengthData: [], //高强度
				xAxisData: [],
				conH: 5500,
				exportPdfFlag: false,
				cpmIndex: 0,
				healthPlan: null,
				physiotherapyCareList: [],
				lifeGuideList: [],
				showPdfFlag: false,
				pdfTimer: null, //设置计时器,
				count: "",
				pointNum: 20,
				pageHeight: 0,
				scroll: 0,
				wellnessList: "",
				healthAssessmentList: [], //健康评估列表
				healthAssessmentImgPath: "", //健康评估图片
				symptomList: [], //健康评估症状列表
				symptomListLeft: [],
				symptomListRight: [],
				physiqueName: "", //体质名称(体质1种时用)
				overview: "", //平和质综述
				loading: false,
				reportResultList: [], //诊断结果
				reportResultListVal: [], //诊断结果字符串
				explainList: [],
				tongueData:[],
				tongueColorData: [], //舌色数据
				tongueShapeData: [], //舌形数据
				furColorData: [], //苔色数据
				furTextureData: [], //苔质数据
				tongueColorDataVal: [], //舌色名称
				tongueShapeDataVal: [], //舌色名称
				furColorDataVal: [], //舌色名称
				furTextureDataVal: [], //舌色名称	
				faceData:[],
				faceColorData: [], //面色数据
				glossData: [], //光泽度
				lipColorData: [], //唇色数据
				eyeData: [], //眼眶数据
				faceColorDataVal: [], //舌色名称
				glossDataVal: [], //舌色名称
				lipColorDataVal: [], //舌色名称
				eyeDataVal: [], //舌色名称						
				physiqueList: [], //体质辨识
				healthPlanList: [],
				dietList: [], //饮食推荐
				gfOrKljData: [], //膏方
				healthFoodList: [], //健康食品
				gaofangUrl: [],
				healthFoodUrlList: [],
				faceUrl:'',
				tongueUrl:'',
				fixedImgHeight:0
			};
		},

		methods: {
			//打印精简报告
			printShort() {
				const loading = this.$loading({
					lock: true,
					text: "拼命加载中,请稍候.....",
					background: "rgba(0, 0, 0, 0.1)",
				});
				window.print();
				setTimeout(() => {
					loading.close();
				}, 2000);
			},
			//直接导出pdf — D03 任务将迁移为后端生成 PDF 下载
			printPDF() {
				const loading = this.$loading({
					lock: true,
					text: "正在生成PDF,请稍候.....",
					background: "rgba(0, 0, 0, 0.1)",
				});
				// TODO(D03): 改为调用后端 /business/report/exportPdf?id=xxx 下载
				window.print();
				setTimeout(() => {
					loading.close();
				}, 2000);
			},
			//膏方链接转二维码
			creatQrCode() {
				// 获取uQRCode实例
				var qr = new UQRCode();
				// 设置二维码内容
				qr.data = this.gaofangUrl;
				// 设置二维码大小，必须与canvas设置的宽高一致
				qr.size = 100;
				// 调用制作二维码方法
				qr.make();
				// 获取canvas元素
				var canvas = document.getElementById("qrcodeGF");
				// 获取canvas上下文
				var canvasContext = canvas.getContext("2d");
				// 设置uQRCode实例的canvas上下文
				qr.canvasContext = canvasContext;
				// 调用绘制方法将二维码图案绘制到canvas上
				qr.drawCanvas();
			},
			//健康食品链接转二维码
			creatQrCodeHealthFood() {
				this.healthFoodUrlList.forEach((item, index) => {
					if (item) {
						// 获取uQRCode实例
						var qr = new UQRCode();
						// 设置二维码内容
						qr.data = item;
						// 设置二维码大小，必须与canvas设置的宽高一致
						qr.size = 100;
						// 调用制作二维码方法
						qr.make();
						// 获取canvas元素
						var canvas = this.$refs.qrCodeUrlHealthFood[index];
						//console.log(canvas);
						// 获取canvas上下文
						var canvasContext = canvas.getContext("2d");
						// 设置uQRCode实例的canvas上下文
						qr.canvasContext = canvasContext;
						// 调用绘制方法将二维码图案绘制到canvas上
						qr.drawCanvas();
					}
				});
			},
			//获取详情接口
			getPulseDetailAll(id) {
				this.$applicationJson("/business/visit/result/detail", {
						id: id, //734
					})
					.then((res) => {
						// console.log(res);
						if (res.data.code == 0) {
							//就诊信息
							this.visitInfo = res.data.data.visitInfo;
							this.age = this.getage(
								this.visitInfo.patient.birth,
								this.visitInfo.visitTime
							);
							//获取诊断结果
							this.getreportResultList(res.data.data.reportResultList);
							//处理舌象数据
							this.getExplainList(res.data.data)

							//体质辨识
							if (res.data.data.physiqueList.length > 0) {
								this.physiqueList = res.data.data.physiqueList;
							}
							//膏方
							if (res.data.data.healthPlanList.length > 0) {
								this.healthPlanList = res.data.data.healthPlanList;
								//饮食推荐dietList						
								this.getDietList();
								//艾灸 拔罐  刮痧
								this.handleAjData(this.healthPlanList[0]);
								this.handleBgData(this.healthPlanList[0]);
								this.handleGsData(this.healthPlanList[0]);
								//获取健康评估
								this.getHealthAssessmentList(this.healthPlanList[0]);
								//膏方	
								this.gfOrKljData = this.healthPlanList[0].medicinalFoodList[0];
								//健康食品
								this.healthFoodList = this.healthPlanList[0].healthFoodList;
								this.healthFoodList.map((item, index) => {
									this.healthFoodUrlList.push(item.buyUri);
								});
								var that = this;
								setTimeout(function(){
									that.fixedImgHeight = that.$refs.content.offsetHeight - 438
								},500)
								
							}
						} else if (res.data.code == 500) {
							this.noDataFlag = true;
							this.$message.error("暂无有效数据");
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			//获取诊断结果
			getreportResultList(reportResultList) {
				//诊断结果
				if (reportResultList.length > 0) {
					this.reportResultList = reportResultList;
					for (let i = 0; i < this.reportResultList.length; i++) {
						this.reportResultListVal.push(this.reportResultList[i].result)
					}
				}
			},
			//获取舌象分析
			getExplainList(item) {
				if (item.explainList.length > 0) {
					this.explainList = item.explainList;
					this.tongueData = item.tongueData;
					this.faceData = item.faceData;
					this.faceUrl = this.faceData.image;
					this.tongueUrl = this.tongueData.image;
					for (let i = 0; i < this.explainList.length; i++) {
						if (this.explainList[i].type == '舌色') {
							this.tongueColorData.push(this.explainList[i]);
							this.tongueColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '舌形') {
							this.tongueShapeData.push(this.explainList[i]);
							this.tongueShapeDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '苔色') {
							this.furColorData.push(this.explainList[i])
							this.furColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '苔质') {
							this.furTextureData.push(this.explainList[i])
							this.furTextureDataVal.push(this.explainList[i].value);
						}
						
						if (this.explainList[i].type == '面色') {
							this.faceColorData.push(this.explainList[i])
							this.faceColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '光泽度') {
							this.glossData.push(this.explainList[i])
							this.glossDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '唇色') {
							this.lipColorData.push(this.explainList[i])
							this.lipColorDataVal.push(this.explainList[i].value);
						}
						if (this.explainList[i].type == '眼眶') {
							this.eyeData.push(this.explainList[i])
							this.eyeDataVal.push(this.explainList[i].value);
						} 						
					}
					
				}
			},
			//获取饮食推荐
			getDietList() {
				//菜肴
				let cuisineList = this.healthPlanList[0].cuisineList;
				//粥实
				let porridgeList = this.healthPlanList[0].porridgeList;
				//汤羹
				let soupList = this.healthPlanList[0].soupList;
				//茶饮
				let teaList = this.healthPlanList[0].teaList;
				this.dietList.push(cuisineList[0]);
				this.dietList.push(porridgeList[0]);
				this.dietList.push(soupList[0]);
				this.dietList.push(teaList[0]);
			},
			//处理艾灸
			handleAjData(healthPlanList) {
				let ajAcupointList = healthPlanList.ajAcupointList;
				let ajAcupointListImgArr = [];
				let ajDataObj = {
					ajContraindication: '',
					ajEfficacy: '',
					ajOperation: '',
					ajPrecaution: '',
					images: '',
					type: ''
				}
				for (let i = 0; i < ajAcupointList.length; i++) {
					ajAcupointListImgArr.push(ajAcupointList[i].images[0]);
				}
				ajDataObj.ajContraindication = healthPlanList.ajContraindication;
				ajDataObj.ajEfficacy = healthPlanList.ajEfficacy;
				ajDataObj.ajOperation = healthPlanList.ajOperation;
				ajDataObj.ajPrecaution = healthPlanList.ajPrecaution;
				ajDataObj.images = ajAcupointListImgArr;
				ajDataObj.type = '艾灸';
				this.physiotherapyCareList.push(ajDataObj);

			},
			//处理拔罐
			handleBgData(healthPlanList) {
				let ajAcupointList = healthPlanList.bgAcupointList;
				let ajAcupointListImgArr = [];
				let ajDataObj = {
					ajContraindication: '',
					ajEfficacy: '',
					ajOperation: '',
					ajPrecaution: '',
					images: '',
					type: ''
				}
				for (let i = 0; i < ajAcupointList.length; i++) {
					ajAcupointListImgArr.push(ajAcupointList[i].images[0]);
				}
				ajDataObj.ajContraindication = healthPlanList.bgContraindication;
				ajDataObj.ajEfficacy = healthPlanList.bgEfficacy;
				ajDataObj.ajOperation = healthPlanList.bgOperation;
				ajDataObj.ajPrecaution = healthPlanList.bgPrecaution;
				ajDataObj.images = ajAcupointListImgArr;
				ajDataObj.type = '拔罐';
				this.physiotherapyCareList.push(ajDataObj);
			},
			//处理艾灸
			handleGsData(healthPlanList) {
				let ajAcupointList = healthPlanList.gsAcupointList;
				let ajAcupointListImgArr = [];

				let ajDataObj = {
					ajSummary: '',
					ajContraindication: '',
					ajEfficacy: '',
					ajOperation: '',
					ajPrecaution: '',
					images: '',
					type: ''
				}
				for (let i = 0; i < ajAcupointList.length; i++) {
					ajAcupointListImgArr.push(ajAcupointList[i].images[0]);
				}
				ajDataObj.ajContraindication = healthPlanList.gsContraindication;
				ajDataObj.ajEfficacy = healthPlanList.gsEfficacy;
				ajDataObj.ajOperation = healthPlanList.gsOperation;
				ajDataObj.ajPrecaution = healthPlanList.gsPrecaution;
				ajDataObj.ajSummary = healthPlanList.gsSummary;
				ajDataObj.images = ajAcupointListImgArr;
				ajDataObj.type = '刮痧';
				this.physiotherapyCareList.push(ajDataObj);
			},
			//健康评估
			getHealthAssessmentList(healthPlanList) {
				this.healthAssessmentList = healthPlanList.healthAssessmentList;
				this.healthAssessmentImgPath = this.healthAssessmentList[0].images[0].path;
				if (this.healthAssessmentList.length == 1) {
					this.symptomList = this.healthAssessmentList[0].symptoms;
					this.symptomList.map((item, index) => {
						if (index <= 2) {
							this.symptomListLeft.push(item);
						}
						if (index > 2) {
							this.symptomListRight.push(item);
						}
					});
					this.physiqueName = healthPlanList.name;
				}
			},
			//出生日期转化为年龄
			getage(date, visitTime) {
				var birthdays = new Date(date.replace(/-/g, "/"));
				var d = new Date(visitTime);
				var age =
					d.getFullYear() -
					birthdays.getFullYear() -
					(d.getMonth() < birthdays.getMonth() ||
						(d.getMonth() == birthdays.getMonth() &&
							d.getDate() < birthdays.getDate()) ?
						1 :
						0);
				return age;
			},
			getRad(degree) {
				return (degree / 180) * Math.PI;
			},

			//重新测量
			remeasure() {
				this.$router.push({
					path: "/inspectionManagement/inspectionManagement",
					query: {
						visitId: this.visitId,
						device: this.device,
					},
				});
			},
			backList() {
				//this.$router.go(-1);
				this.$router.push({
					path: "/historyList/reportOverview",
				});
			},
			//打印
			print() {
				this.centerDialogVisible = true;
				setTimeout(() => {
					this.creatQrCode();
					this.creatQrCodeHealthFood();
				}, 2000);
				this.timerTwo = null;
				clearInterval(this.timerTwo);
				this.stateDemo.beatArray = [];
				this.stateTwoDemo.beatArray = [];
				this.stateThreeDemo.beatArray = [];
				let graphValue = this.graphValue;
				if (graphValue) {
					let beatArray = graphValue.split(";");
					this.stateDemo.beatArray = beatArray[0].split(",");
					this.stateTwoDemo.beatArray = beatArray[1].split(",");
					this.stateThreeDemo.beatArray = beatArray[2].split(",");
				}
				let TIME_COUNT = 6;
				if (!this.pdfTimer) {
					this.count = TIME_COUNT;
					this.showPdfFlag = false;
					this.pdfTimer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.showPdfFlag = true;
							clearInterval(this.pdfTimer);
							this.pdfTimer = null;
						}
					}, 1000);
				}
				this.$nextTick(() => {
					let imageWrapper = document.getElementById("pdfDom"); // 获取DOM
					let pageHeight = imageWrapper.offsetWidth;
					if (pageHeight == 1000) {
						this.stateDemo.height = 421;
						this.stateTwoDemo.height = 421;
						this.stateThreeDemo.height = 421;
					}
					setTimeout(() => {

						this.drawDemo(this.canvasTwoArr);
						this.drawOneDemo(this.canvasOneArr);
						this.drawTwoDemo(this.canvasArr);
						this.drawLineDiaog(
							this.valOne,
							this.valTwo,
							this.valThree,
							this.valFour
						);

					}, 10);
				});
			},


			//同步辅诊
			synchronization() {
				this.$applicationJson("/docking/back", {
						outToken: this.loginInfo.outToken,
						outVisitId: this.outVisitId,
						result: this.pulseResult,
					})
					.then((res) => {
						//console.log(res)
						if (res.data.code == 0) {
							this.$message.success("同步辅诊成功");
						} else {
							alert(res.data.msg);
						}
					})
					.catch((Error) => {
						this.$message.error("网络异常");
					});
			},
			liquidCharts(id, data, borderC, colorS, colorE, name) {
				let dom = document.getElementById(id);
				let myChart = this.echarts.init(dom);
				myChart.getZr().on("mousemove", (param) => {
					var pointInPixel = [param.offsetX, param.offsetY];
					if (myChart.containPixel("grid", pointInPixel)) {
						//若鼠标滑过区域位置在当前图表范围内 鼠标设置为小手
						myChart.getZr().setCursorStyle("pointer");
					} else {
						myChart.getZr().setCursorStyle("default");
					}
				});
				let option = null;
				option = {
					// 图表主标题
					title: {
						show: false,
						text: "槽使用情况",
						// x 设置水平安放位置，默认左对齐，可选值：'center' ¦ 'left' ¦ 'right' ¦ {number}（x坐标，单位px）
						x: "10px",
						// y 设置垂直安放位置，默认全图顶端，可选值：'top' ¦ 'bottom' ¦ 'center' ¦ {number}（y坐标，单位px）
						y: "0px",
						// itemGap设置主副标题纵向间隔，单位px，默认为10，
						itemGap: 30,
						backgroundColor: "#fff",

						// 主标题文本样式设置
						textStyle: {
							fontSize: 16,
							fontWeight: "500",
							color: "#999",
						},
						// 副标题文本样式设置
					},
					// 提示框组件
					tooltip: {
						trigger: "item", // 触发类型, 数据项图形触发，主要在散点图，饼图等无类目轴的图表中使用。
						textStyle: {
							color: "#999", // 文字颜色
						},
						// 提示框浮层内容格式器，支持字符串模板和回调函数两种形式
						// 水球图: {a}（系列名称），{b}（无），{c}（数值）
						// 使用函数模板   传入的数据值 -> value: number|Array,
						formatter: function(value) {
							//return value.seriesName + ": " + value.data * 100 + "%";
						},
					},
					series: [{
						type: "liquidFill",
						name: name, // 系列名称，用于tooltip的显示，legend 的图例筛选
						radius: "89%", // 水球图的半径
						center: ["52%", "55%"], // 水球图的中心（圆心）坐标，数组的第一项是横坐标，第二项是纵坐标
						// 水填充图的形状 circle 默认圆形  rect 圆角矩形  triangle 三角形
						// diamond 菱形  pin 水滴状 arrow 箭头状  还可以是svg的path
						shape: "circle",
						phase: 0, // 波的相位弧度 不设置  默认自动
						waveAnimation: false, //停止动画 动画占用cpu过高 核心代码
						animationDuration: 0, //停止动画 动画占用cpu过高 核心代码
						animationDurationUpdate: 0, //停止动画 动画占用cpu过高 核心代码
						direction: "right", // 波浪移动的速度  两个参数  left 从右往左 right 从左往右
						amplitude: 4, //振幅设置为0，表示水平波浪
						outline: {
							show: true,
							borderDistance: 0, // 边框线与图表的距离 数字
							itemStyle: {
								opacity: 0.9, // 边框的透明度   默认为 1
								borderWidth: 2, // 边框的宽度
								shadowBlur: 14, // 边框的阴影范围 一旦设置了内外都有阴影
								//shadowColor: "#fff", // 边框的阴影颜色,
								borderColor: borderC, // 边框颜色
							},
						},
						// 图形样式
						itemStyle: {
							//color:'#fff', // 水球显示的背景颜色
							opacity: 1, // 波浪的透明度
							shadowBlur: 1, // 波浪的阴影范围
						},
						backgroundStyle: {
							color: "#fff", // 水球未到的背景颜色
						},
						// 图形的高亮样式
						emphasis: {
							itemStyle: {
								opacity: 1, // 鼠标经过波浪颜色的透明度
							},
						},
						// 图形上的文本标签
						label: {
							fontSize: 26,
							fontWeight: 400,
							show: false,
						},
						color: [{
							type: "linear",
							x: 0,
							y: 1,
							x2: 0,
							y2: 0,
							colorStops: [{
									offset: 1,
									color: colorS, // 0% 处的颜色
								},
								{
									offset: 0,
									color: colorE, // 100% 处的颜色
								},
							],
							global: false, // 缺省为 false
						}, ],
						data: data, // 系列中的数据内容数组
					}, ],
				};
				if (option && typeof option === "object") {
					myChart.setOption(option);
				}
			},
			drawLine(arr1, arr2, arr3, arr4) {
				//基于准本好的DOM，初始化echarts实例
				this.liquidCharts(
					"chartmainbar1", //参数1 id:加载的dom元素的id
					[arr1], //参数2 data:加入的数据,例如：[0.6]表示60%
					["#dbdbdb"], //参数3 borderD:边框颜色
					["#8FEFBD"], //参数4 color0:设置渐变色--水波图0%处的颜色
					["#7DADF6"], //参数5 color100:设置渐变色--水波图100%处的颜色
					"八纲"
				);
				this.liquidCharts(
					"chartmainbar2",
					[arr2],
					["#dbdbdb"],
					["#EB8715"],
					["#FFDDA0"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbar3",
					[arr3],
					["#dbdbdb"],
					["#BBD2F6"],
					["#9DDEFA"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbar4",
					[arr4],
					["#dbdbdb"],
					["#FFE88E"],
					["#CC7650"],
					"八纲"
				);
			},
			drawLineDiaog(arr1, arr2, arr3, arr4) {
				//console.log(arr1)
				//基于准本好的DOM，初始化echarts实例
				this.liquidCharts(
					"chartmainbarOne", //参数1 id:加载的dom元素的id
					[arr1], //参数2 data:加入的数据,例如：[0.6]表示60%
					["#dbdbdb"], //参数3 borderD:边框颜色
					["#8FEFBD"], //参数4 color0:设置渐变色--水波图0%处的颜色
					["#7DADF6"], //参数5 color100:设置渐变色--水波图100%处的颜色
					"八纲"
				);
				this.liquidCharts(
					"chartmainbarTwo",
					[arr2],
					["#dbdbdb"],
					["#EB8715"],
					["#FFDDA0"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbarThree",
					[arr3],
					["#dbdbdb"],
					["#BBD2F6"],
					["#9DDEFA"],
					"八纲"
				);
				this.liquidCharts(
					"chartmainbarFour",
					[arr4],
					["#dbdbdb"],
					["#FFE88E"],
					["#CC7650"],
					"八纲"
				);
			},

			async handleImgUrl(data) {
				data.dietList = data.dietList.reverse();
				/* for (let i = 0; i < data.dietList.length; i++) {
					for (let j = 0; j < data.dietList[i].images.length; j++) {
						let base64 = await this.getImgBase64(this.GLOBAL.imgPath + data.dietList[i].images[j].path)
						data.dietList[i].images[j].path = base64;
					}
				}
				for (let i = 0; i < data.acupointList.length; i++) {
					for (let j = 0; j < data.acupointList[i].images.length; j++) {
						data.acupointList[i].images[j].path = await this.getImgBase64(this.GLOBAL.imgPath + data.acupointList[i].images[
							j].path)
					}
				} */
				this.regimenDetail = data;
			},

			getImgBase64(url) {
				return new Promise((resolve, reject) => {
					let base64 = "";
					let img = new Image();
					img.src = url;
					img.crossOrigin = "*";
					img.onload = function() {
						let canvas = document.createElement("canvas");
						canvas.width = img.width;
						canvas.height = img.height;
						let ctx = canvas.getContext("2d");
						ctx.drawImage(img, 0, 0, img.width, img.height);
						base64 = canvas.toDataURL("image/png");
						resolve(base64);
					};
					img.ononerror = function(e) {
						reject(e);
					};
				});
			},

			//导出PDF
			exportPdf() {
				let ST = document.documentElement.scrollTop || document.body.scrollTop;
				let SL = document.documentElement.scrollLeft || document.body.scrollLeft;
				document.documentElement.scrollTop = 0;
				document.documentElement.scrollLeft = 0;
				document.body.scrollTop = 0;
				document.body.scrollLeft = 0;
				//debugger;
				//获取滚动条的位置并赋值为0，因为是el-dialog弹框，并且内容较多出现了纵向的滚动条,截图出来的效果只能截取到视图窗口显示的部分,超出窗口部分则无法生成。所以先将滚动条置顶
				const A4_WIDTH = 592.28;
				const A4_HEIGHT = 841.89;
				let imageWrapper = document.getElementById("pdfDom"); // 获取DOM
				let pageHeight = (imageWrapper.offsetWidth / A4_WIDTH) * A4_HEIGHT;
				let lableListID = imageWrapper.querySelectorAll(".itemHeight");
				for (let i = 0; i < lableListID.length; i++) {
					let multiple = Math.ceil(
						(lableListID[i].offsetTop + lableListID[i].offsetHeight) / pageHeight
					);
					if (this.isSplit(lableListID, i, multiple * pageHeight)) {
						let divParent = lableListID[i].parentNode; // 获取该div的父节点
						let _H =
							multiple * pageHeight -
							(lableListID[i].offsetTop + lableListID[i].offsetHeight);
						let newNode = this.getFooterElement(_H);

						let next = lableListID[i].nextSibling; // 获取div的下一个兄弟节点
						// 判断兄弟节点是否存在
						if (next) {
							// 存在则将新节点插入到div的下一个兄弟节点之前，即div之后
							divParent.insertBefore(newNode, next);
						} else {
							// 不存在则直接添加到最后,appendChild默认添加到divParent的最后
							divParent.appendChild(newNode);
						}
					}
				}
				/* this.$nextTick(() => {
					let nam =
						"脉诊仪报告_" +
						this.visitInfo.patient.name +
						"_" +
						this.visitInfo.visitTime.substring(0, 10) +
						"";
					this.getPdf("pdfDom", nam);
					//downloadPDF(document.querySelector("#pdfDom"), "test");
					var that = this;
					setTimeout(function() {
						that.centerDialogVisible = false;
					}, 2000);
				}); */
			},
			isSplit(nodes, index, pageHeight) {
				return (
					nodes[index].offsetTop + nodes[index].offsetHeight < pageHeight &&
					nodes[index + 1] &&
					nodes[index + 1].offsetTop + nodes[index + 1].offsetHeight > pageHeight
				);
			},
			/**
			 * @description: 获取底部元素
			 */
			getFooterElement(remainingHeight, fillingHeight = 5) {
				let cpmItem = document.getElementById("cpmItem"); // 获取DOM
				if (cpmItem) {
					let imageWrapper = document.getElementById("pdfDom"); // 获取DOM
					if (imageWrapper.offsetWidth == 1000) {
						cpmItem.parentNode.style.marginTop = "150px";
					}
				}
				let newNode = document.createElement("div");
				newNode.style.background = "#ffffff";
				newNode.className = "emptyDiv";
				newNode.style.width = "calc(100% + 8px)";
				newNode.style.marginLeft = "-4px";
				newNode.style.marginBottom = "0px";
				newNode.style.float = "left";
				newNode.style.height = remainingHeight + fillingHeight + "px"; // pdf截断需要一个空白位置
				return newNode;
			},


			//运动生活
			myEcharts(runChart) {
				let myChart = this.echarts.init(document.getElementById(runChart));
				//绘制图表
				var optionOne = {
					title: {
						text: "运动适宜心率",
						left: "center",
						textStyle: {
							//文字颜色
							color: "#333",
							//字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
							fontWeight: "normal",
							//字体大小
							fontSize: 16,
						},
					},
					tooltip: {
						trigger: "axis",
						axisPointer: {
							type: "cross",
							label: {
								backgroundColor: "#6a7985",
							},
						},
					},
					legend: {
						orient: "vertical",
						right: "left",
						bottom: "20%",
						data: ["高强度", "中强度", "低强度"],
					},

					grid: {
						left: "30",
						right: "14%",
						bottom: "3%",
						containLabel: true,
					},
					xAxis: [{
						type: "category",
						boundaryGap: false,
						data: this.xAxisData,
						name: "年龄（岁）",
					}, ],
					yAxis: [{
						type: "value",
						min: 60,
						max: 180,
						interval: 60,
						name: "心率（次/分钟）",
					}, ],
					series: [{
							name: "高强度",
							type: "line",
							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#8BE041",
									lineStyle: {
										color: "#8BE041",
									},
								},
							},
							areaStyle: {
								normal: {
									//由上到下的渐变
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: "#8BE041",
										},
										{
											offset: 0.24,
											color: "#8BE041",
										},
										{
											offset: 0.25,
											color: "#7FA7E7",
										},
										{
											offset: 1,
											color: "#F0AF85",
										},
									]),
								},
							},
							data: this.highStrengthData,
						},
						{
							name: "中强度",
							type: "line",
							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#7FA7E7",
									lineStyle: {
										color: "#7FA7E7",
									},
								},
							},
							areaStyle: {
								normal: {
									//由上到下的渐变
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: "#7FA7E7",
										},
										{
											offset: 0.05,
											color: "#7FA7E7",
										},
										{
											offset: 1,
											color: "#F0AF85",
										},
									]),
								},
							},

							data: this.medialStrengthData,
						},
						{
							name: "低强度",
							type: "line",

							emphasis: {
								focus: "series",
							},
							itemStyle: {
								normal: {
									color: "#F0AF85",
									lineStyle: {
										color: "#F0AF85",
									},
								},
							},
							areaStyle: {
								normal: {
									//由上到下的渐变
									color: new this.echarts.graphic.LinearGradient(0, 0, 0, 1, [{
											offset: 0,
											color: "#F0AF85",
										},
										{
											offset: 1,
											color: "#F0AF85",
										},
									]),
								},
							},
							data: this.LowStrengthData,
						},
					],
				};
				myChart.setOption(optionOne); //设置option
				let index = this.xAxisData.indexOf(this.age);
				myChart.dispatchAction({
					type: "showTip",
					seriesIndex: 0, // 显示第几个series，从0开始
					dataIndex: index, // 显示第几个数据，从0开始
				});
				myChart.on("globalout", function(params) {
					// 显示 tooltip
					myChart.dispatchAction({
						type: "showTip",
						seriesIndex: 0,
						dataIndex: index,
					});
				});
			},
			initStrengthData() {
				//console.log(this.age)
				let xAxisData = [6, 18, 50, 65, 80];
				let LowStrengthData = [125, 125, 102, 69, 45];
				let medialStrengthData = [145, 145, 119, 80, 56];
				let highStrengthData = [165, 165, 136, 92, 64];
				if (this.age < 6) {
					this.xAxisData = xAxisData;
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
				}
				if (this.age >= 6 && this.age <= 18) {
					this.xAxisData = xAxisData;
					if (this.age < 18) {
						this.xAxisData.splice(1, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					this.LowStrengthData.splice(1, 0, 125);
					this.medialStrengthData.splice(1, 0, 145);
					this.highStrengthData.splice(1, 0, 165);
				}
				if (this.age > 19 && this.age <= 50) {
					this.xAxisData = xAxisData;
					if (this.age < 50) {
						this.xAxisData.splice(2, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					let lowData = Math.floor((220 - this.age) * 0.6);
					let medeialData = Math.floor((220 - this.age) * 0.7);
					let highData = Math.floor((220 - this.age) * 0.8);
					this.LowStrengthData.splice(2, 0, lowData);
					this.medialStrengthData.splice(2, 0, medeialData);
					this.highStrengthData.splice(2, 0, highData);
				}
				if (this.age > 50 && this.age <= 65) {
					this.xAxisData = xAxisData;
					if (this.age < 65) {
						this.xAxisData.splice(3, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					let lowData = Math.floor((170 - this.age) * 0.6);
					let medeialData = Math.floor((170 - this.age) * 0.7);
					let highData = Math.floor((170 - this.age) * 0.8);
					this.LowStrengthData.splice(3, 0, lowData);
					this.medialStrengthData.splice(3, 0, medeialData);
					this.highStrengthData.splice(3, 0, highData);
				}
				if (this.age > 66 && this.age <= 80) {
					this.xAxisData = xAxisData;
					if (this.age < 80) {
						this.xAxisData.splice(4, 0, this.age);
					}
					this.LowStrengthData = LowStrengthData;
					this.medialStrengthData = medialStrengthData;
					this.highStrengthData = highStrengthData;
					let lowData = Math.floor((170 - this.age) * 0.6 * 0.9);
					let medeialData = Math.floor((170 - this.age) * 0.7 * 0.9);
					let highData = Math.floor((170 - this.age) * 0.8 * 0.9);
					this.LowStrengthData.splice(4, 0, lowData);
					this.medialStrengthData.splice(4, 0, medeialData);
					this.highStrengthData.splice(4, 0, highData);
				}
			},
			//切换丸
			changeCpmList(index) {
				this.cpmIndex = index;
			},
			//去播放视频视频
			goLookVideo(com, item) {
				if (com == "one") {
					let videoPlayDetail = item;
					localStorage.setItem(
						"videoPlayDetail",
						JSON.stringify(videoPlayDetail)
					);
					localStorage.setItem("acupointList", "");
				} else {
					let acupointList = this.healthPlan.acupointList;
					localStorage.setItem("acupointList", JSON.stringify(acupointList));
					localStorage.setItem("masterMediaUri", "");
				}
				this.$router.push({
					path: "/historyList/lookVideo",
					query: {
						com: com,
					},
				});
			},
			//去购买膏方
			goBuy() {
				window.open(this.gfOrKljData.buyUri, '_blank');
			},
			//去购买健康食品
			goBuyJKSP(url) {
				window.open(url, '_blank');
			},
			//总体结构
			formatProgress(percentage) {
				let tex = '健康得分'
				return percentage + '分\n' + tex
			}
		},
		created() {
			this.$nextTick(() => {
				this.visitId = this.$route.query.visitId;
				this.device = this.$route.query.device;
				if (this.$route.query.outVisitId) {
					this.outVisitId = this.$route.query.outVisitId;
				}
				this.pulseResult = this.$route.query.pulseResult;
				this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
				this.getPulseDetailAll(this.visitId);

			});
		},
		mounted() {
			this.$nextTick(() => {});
		},
		activated() {
			this.$refs.box.scrollTop = this.scroll;
		},
		/* beforeRouteLeave(to, from, next) {
			if (to.name != "lookVideo") {
				let key = this.$vnode.componentOptions.Ctor.cid;
				//获取所有路由的key值
				let keys = this.$vnode.parent.componentInstance.keys;
				if (null != key && undefined != key) {
					//将需要清空路由缓存的key移除
					keys.splice(keys.indexOf(key), 1);
					//获取该key值对应的缓存
					let cache = this.$vnode.parent.componentInstance.cache;
					//删除该缓存
					delete cache[key];
				}
			} else {
				this.scroll = this.$refs.box.scrollTop;
			}
			next();
		}, */
	};
</script>

<style lang="less" scoped="scoped">
	@import "../../../static/css/layout.less";
	@import "../../../static/css/report.less";
	@import "../../../static/css/print.less";

	.independent-wrapper {
		overflow-y: auto;
		font-variant: normal;
		overflow-x: hidden;

		:deep(.el-loading-mask){
			position: fixed;
			left: 0;
			top: 60px;
		}

		.gfitem {
			box-shadow: 0px 3px 4px 0px rgba(204, 204, 204, 0.25) !important;
			border-radius: 8px !important;
			border: 1px solid #e5e5e5 !important;
		}

		.symptomTop {
			margin-top: 0px;
			font-size: 14px;
			margin-left: 60px;
			font-weight: bold;
			margin-bottom: 20px;

			&.symptomTop-yl {
				color: #4c5159;

				@media (min-width: 1900px) {
					font-size: 16px;
				}
			}
		}

		.symptomBottom {
			display: flex;
			padding-bottom: 20px;
			margin:0 auto;
			width: 900px;			
			@media (min-width: 1900px) {
				width: 1040px;
			}
			&.symptomBottom-yl {
				color: #4c5159;
			}

			.symptomLeft {
				width: 320px;
				display: flex;

				&.symptomLeft-yl {
					@media (min-width: 1900px) {
						width: 32%;
						margin-top: 50px;
						padding-left: 60px;
					}
				}

				

				&.symptomLeftPHZ {
					@media (min-width: 1900px) {
						width: 30%;
					}
				}

				.symptomItem {
					width: 70px;
					height: 70px;
					border-radius: 10px;
					border: 2px solid #ade0d5;
					box-shadow: 0 0 5px #ade0d5;
					background: #e6f6f5;
					opacity: 0.8;
					margin-top: 18px;
					font-size: 14px;
					font-weight: bold;
					line-height: 20px;
					text-align: center;
					margin-right: 20px;
					display: flex;
					align-items: center;
					justify-content: center;

					&.symptomItemChild {
						width: 70px;
						height: 70px;

						&:nth-child(1) {
							margin-top: 80px;
						}
					}

					&.symptomItem-yl {
						@media (min-width: 1900px) {
							font-size: 16px;
						}
					}

					&:nth-child(1) {
						margin-top: 80px;
					}

					&:nth-child(3) {
						margin-bottom: 40px;
					}

					&.symptomItemRight {
						margin-left: 20px;

						&:nth-child(1) {
							margin-top: 20px;
						}

						&.symptomItemChildRight {
							width: 70px;
							height: 70px;

							&:nth-child(1) {
								margin-top: 40px;
							}
						}
					}
				}
				

				.image {
					img {
						width: 100px;
					}
				}
			}

			.symptomRight {
				width: calc(100% - 320px);
				

				.symptomItems {
					margin-bottom: 40px;
					float: left;
					width:100%;
					.symptomItem {
						font-size: 14px;
						margin-top: 10px;
						width: 33.3%;
						float:left;
						height:200px;
						
						&.symptomItemPHZ {
							width: 550px;
							line-height: 25px;
							font-size: 14px;
							color: #4c5159;

							@media (min-width: 1900px) {
								width: 660px;
								margin-top: 30px;
							}

							&.symptomItemPHZ-ly {
								@media (min-width: 1900px) {
									font-size: 16px;
								}
							}
						}

						.title {
							width: 190px;
							margin-right: 15px;
							font-weight: bold;
							line-height: 30px !important;
							height: 30px;
							margin-top: 3px;
							padding: 0 10px;
							span{
								width: 4px;
								height: 4px;
								background: #679FF6;
								margin-top: 13px;
								margin-right: 5px;
								border-radius: 4px;
								float: left;
							}
							&.title-yl {
								font-size: 14px;
								color: #4c5159;

								@media (min-width: 1900px) {
									width: 90px;
									font-size: 16px;
								}
							}
						}

						.content {
							width: 190px;							
							line-height: 25px;
							padding: 0 40px 0 10px;
							margin: 0;
							margin-left: 9px;
							span{
								color: #666;
							}
							&.content-yl {
								@media (min-width: 1900px) {
									font-size: 16px;
									height: 140px;
								}
							}
						}
						.maintenanceOne{
							margin: 20px 0;
							padding-left: 20px;
							font-weight: bold;
						}
						
					}
					.symptomItemOne{
						width: 100%;
						height:300px;
						.content{
							width: 100%;
						}
						.maintenance{
							margin-top: 20px;
						}
					}
				}
			}
		}
	}

	:deep(.el-dialog__header){
		display: none;
	}

	:deep(.el-dialog__body){
		padding-left: 0 !important;
		padding-right: 0 !important;
	}

	.pulseResult-right {
		float: right;

		.circleBox {
			position: relative;
			text-align: center;
			width: 200px;
			margin: 40px 0;
			float: right;

			.circleCenter {
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);

				div {
					font-size: 26px;
					color: #1360FB;
					font-weight: 600;
					margin-bottom: 5px;
				}

				span {
					font-size: 14px;
					color: #999999;
				}
			}
		}

	}
</style>
